import './Sample.component.css'

import { Circle } from 'react-konva'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

export class SampleComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hovered: false,
    }
  }

  getKonvaCircle(
    radius,
    sample_container_position_from_top,
    sample_container_position_from_left,
    sample_container_background_color,
    sample_container_border_color,
    sample_container_border_size,
    onClickFunction
  ) {
    return (
      <Circle
        ref={ref => (this.circle = ref)}
        onClick={onClickFunction}
        radius={radius}
        y={sample_container_position_from_top}
        x={sample_container_position_from_left}
        fill={sample_container_background_color}
        stroke={this.state.hovered ? 'yellow' : sample_container_border_color}
        strokeEnabled
        strokeWidth={this.state.hovered ? '3' : sample_container_border_size}
        onMouseOver={() => {
          this.props.onMouseOverSample(
            this.props.sample.sampleName,
            this.props.sample.proteinAcronyme,
            this.props.sample.position,
            this.props.sample.status
          )

          this.setState({
            hovered: true,
          })
        }}
        onMouseOut={() => {
          this.props.onMouseOverSample(null, null, null, null)

          this.setState({
            hovered: false,
          })
        }}
      />
    )
  }

  shouldComponentUpdate() {
    return true
  }

  componentWillUnmount() {
    this.circle.destroy()
  }

  render() {
    return this.getKonvaCircle(
      this.props.configuration.sample_radius,
      this.props.sample_position_from_top,
      this.props.sample_position_from_left,
      this.props.configuration.sample_container_state_legend[this.props.sample.status].drawing
        .sample_container_background_color,
      this.props.configuration.sample_container_state_legend[this.props.sample.status].drawing
        .sample_container_border_color,
      this.props.configuration.sample_container_state_legend[this.props.sample.status].drawing
        .sample_container_border_size,
      this.props.onClickFunction
    )
  }
}

export default connect()(SampleComponent)

SampleComponent.propTypes = {
  type: PropTypes.string,
  sample_radius: PropTypes.number,
  sample_position_from_top: PropTypes.number,
  sample_position_from_left: PropTypes.number,
  sample_background_color: PropTypes.string,
  sample_border_color: PropTypes.string,
  sample_border_size: PropTypes.number,
}
